export default __webpack_public_path__ + "static/media/repetitivo.affc7591.svg";